import { render, staticRenderFns } from "./ClaimMembershipRewardSetting.vue?vue&type=template&id=7d60e118&"
import script from "./ClaimMembershipRewardSetting.vue?vue&type=script&lang=js&"
export * from "./ClaimMembershipRewardSetting.vue?vue&type=script&lang=js&"
import style0 from "./ClaimMembershipRewardSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports